import ChatCollapse from './ChatCollapse'

export default ChatCollapse
